import { EnumColor } from '@40seas/frontend/common/providers';
import { ErpSyncSystemStatus } from 'libs/entities/erp-sync/src/lib/erp-system-status.enum';

export const erpSyncSystemStatusColorMapping = {
    [ErpSyncSystemStatus.InSync]: 'success',
    [ErpSyncSystemStatus.OutOfSync]: 'error',
} as {
    [key in ErpSyncSystemStatus]: EnumColor;
};
